import { NavLink } from "react-router-dom";
import "./AdminLayout.scss";

const AdminLayout = (props) => {
    return (
        <div className="admin-dashboard-container animate-fade-in">
            <div className="d-flex flex-column">
                <h3 className="content-label">Admin Dashboard</h3>
                <p className="content-sub-label fw-bold text-gray">Manage users, plans and system settings</p>
            </div>

            <div className="admin-tabs mt-3">
                <NavLink to="/admin" exact className="admin-tab" activeClassName="admin-tab-active">
                    Dashboard
                </NavLink>
                <NavLink to="/admin/users" className="admin-tab" activeClassName="admin-tab-active">
                    Users
                </NavLink>
                <NavLink to="/admin/plans" className="admin-tab" activeClassName="admin-tab-active">
                    Plans
                </NavLink>
            </div>

            <div className="admin-content mt-3">
                {props.children}
            </div>
        </div>
    );
};

export default AdminLayout;